module.exports = __webpack_public_path__ + "img/sina.3ebc54c6.png";